import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { InclusionFormType } from '../InclussionsForm';

export default function IncludesFields() {
  const { control, register } = useFormContext<InclusionFormType>();

  const { fields, append, remove } = useFieldArray<any>({
    control,
    name: 'includes',
  });

  return (
    <Col xs={12} className="py-3">
      <div className="mb-3 leading">Includes</div>
      <Row>
        {fields.map(
          (
            field,
            index, // eslint-disable-next-line react/no-array-index-key
          ) => (
            // eslint-disable-next-line react/no-array-index-key
            <Col key={index} xs={12} className="py-2">
              <InputGroup>
                <Form.Control
                  type="text"
                  key={field.id} // important to include key with field's id
                  {...register(`includes.${index}`)}
                />
                <Button
                  variant="outline-danger"
                  type="button"
                  onClick={() => remove(index)}
                >
                  Delete
                </Button>
              </InputGroup>
            </Col>
          ),
        )}
        <Col xs={12}>
          <Button variant="primary" type="button" onClick={() => append('')}>
            Add
          </Button>
        </Col>
      </Row>
    </Col>
  );
}
